import { render } from "./AppPaymentsBody.vue?vue&type=template&id=251165ae&ts=true"
import script from "./AppPaymentsBody.vue?vue&type=script&lang=ts"
export * from "./AppPaymentsBody.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__